import React, { useState } from 'react';

import './Home.css';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PhoneIcon from '@mui/icons-material/Phone';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
// TODO: Add animated background

function Home() {
  const [openIndex, setOpenIndex] = useState(null);
  const jobs = [
    {
      name: 'ForwardTech',
      role: 'Freelance Software Engineer',
      year: 'December 2023 - June 2025',
      description: "Initiated end-to-end development of applications using Python, React, AWS, etc. Continuously advanced skills through collaboration with developers, and engineering communities. Gathered requirements and delivered effective solutions."
    },
    {
      name: 'SayKid',
      role: 'Software Engineer Intern',
      year: 'June 2022 - September 2022',
      description: "Improved code quality through peer reviews and hands on experience with AWS, DynamoDB, NoSQL, and PHP. Developed features using NLP and JavaScript to enhance functionality and user experience. Created performance visualizations and comprehensive documentation to support product insights and development clarity."
    },
    {
      name: 'SayKid',
      role: 'Software Developer Extern',
      year: 'November 2021 - December 2021',
      description: 'Developed interactive software using NLP and JavaScript, boosting user engagement and retention. Contributed to strategic planning in team meetings and helped shape the product’s creative and technical vision. Implemented an API to enhance search query intuition and response quality.'
    },
  ];

  const handleToggle = idx => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className='home'>
      <div className='home_row1'>
        <div className='image_container'>
          {/* TODO: Consider gif or transitioning images of prof me over years */}
          <img src="/profme.PNG" alt="image" className='home_image'></img>
          
        </div>
        <div className='home_about'>
          <h1>
            Experience
          </h1>
          <div className="experience_container">
            {jobs.map((job, idx) => (
              <div className="job_card" key={idx}>
                <div className="job_info_row">
                  <h3 className="job_name">{job.name}</h3>
                  <button className="more_details_btn" onClick={() => handleToggle(idx)}>
                    {openIndex === idx ? 'Hide Details' : 'More Details'}
                  </button>
                </div>
                <div className="role_details">
                  <span className="job_role">{job.role}</span>
                  <span className="job_year">{job.year}</span>
                </div>
                {openIndex === idx && (
                  <div className="job_description">{job.description}</div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className='home_about'>
          <h1>
            About Me
          </h1>
          {/* TODO: Highlight important details */}
          <p> My name is <b>Rodrick Lankford</b>. I am an engineer from <b>Dallas, Texas</b> with a strong foundation
              in computer science, <b>machine learning</b>, and software engineering fundamentals. 
              I have a <b>B.A.</b> in <b>Computer Science</b> from <b>Carleton College</b>, which allowed me to broaden my horizons by exploring 
              diverse subjects, such as creative storytelling and writing, cultural and societal dynamics, physics fundamentals, 
              and advanced mathematics. My interests, 
              and areas of ongoing, self-guided studies, include innovation within the <b>healthcare</b>, <b>tech</b>,
              and <b>quantum computing</b> sectors.</p>
          

          {/* <form method="get" action="Rodrick V. Lankford's Resume.pdf">
            <button type="submit" className='button'>Download Resume!</button>
          </form> */}
        </div>
      </div>

    </div>
  )
}

export default Home
